'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = SvgIcon;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var sizeMap = {
  small: 15,
  medium: 20,
  large: 25
};

function SvgIcon(_ref) {
  var children = _ref.children,
      color = _ref.color,
      size = _ref.size,
      style = _ref.style,
      viewBox = _ref.viewBox,
      other = _objectWithoutProperties(_ref, ['children', 'color', 'size', 'style', 'viewBox']);

  var resultSize = sizeMap[size] || size;

  var resultStyle = _extends({
    width: resultSize,
    height: resultSize,
    display: 'inline-block',
    userSelect: 'none',
    fill: color
  }, style);

  var resultChildren = typeof children === 'function' ? children(resultSize) : children;

  return _react2.default.createElement(
    'svg',
    _extends({}, other, { viewBox: viewBox, style: resultStyle }),
    resultChildren
  );
}

SvgIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Дополнительный класс для иконки
   */
  className: _propTypes2.default.string,
  /**
   * Дополнительные инлайновые стили для иконки
   */
  style: _propTypes2.default.object,
  /**
   * Цвет иконки
   */
  color: _propTypes2.default.string,
  /**
   * Элементы, которые отрисуются внутри svg-элемента,
   * ожидается `ReactElement` или функция возвращающая его и получающая размер как аргумент `size => ReactElement`
   */
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  /**
   * Размер иконки. Может быть строкой или значением в пикселях
   */
  size: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['small', 'medium', 'large']), _propTypes2.default.number, _propTypes2.default.string]),
  /**
   * Атрибут viewBox svg-элемента
   */
  viewBox: _propTypes2.default.string
} : {};

SvgIcon.defaultProps = {
  viewBox: '0 0 20 20',
  size: 'medium',
  style: {},
  color: 'black'
};